import { IconProps } from "./types";

const HelpIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/disclaimer.svg" alt="" />;
};

export default HelpIcon;
